import { MsalProvider } from "@azure/msal-react";
import { ReactNode } from "react";

import { msalInstance } from "./msalConfig";
import { useSilentAuth } from "./useSilentAuth";

const MsalAppProviderSSO = ({ children }: { children: ReactNode }) => {
  useSilentAuth();

  return (
    <>
      {children}
    </>
  );
};

export const MsalAppProvider = ({ children }: { children: ReactNode }) => {
  return (
    <MsalProvider instance={msalInstance}>
      <MsalAppProviderSSO>
        {children}
      </MsalAppProviderSSO>
    </MsalProvider>
  );
};